import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Section, Container, BackgroundImage } from './common'

const Header = styled.header``
const FeaturedImage = styled(Section)`
  height: 35vw;
  max-height: 35rem;
`
const Title = styled.h1`
  color: inherit;
  font-size: 3rem;
  margin-top: 3.5rem;
  margin-bottom: 0;
`

const PageHeader = ({title, subtitle, image}) => (
  <Header>
    { image && (
      <FeaturedImage relative dark>
        <BackgroundImage image={image} />
      </FeaturedImage>
    )}
    <Container>
      <Title>{title}</Title>
      {subtitle ? <h2>{subtitle}</h2> : ''}
    </Container>
  </Header>
)

PageHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  image: PropTypes.string
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/PageHeader.js